import React from "react";
import SEO from "../components/SEO";
import { HomePromoBanner } from "../components/PromoBanner";
import { OfferHero } from "../components/home/OfferHero";
import { HomeInstallGallery } from "../components/InstallGallery";
import { BrandsBand } from "../components/home/BrandsBand";
import { OfferSteps } from "../components/home/OfferSteps";
import { InstallPricing } from "../components/home/InstallPricing";
import { PriceFactors } from "../components/home/PriceFactors";
import { HowQuotingWorks } from "../components/home/HowQuotingWorks";
import { InstallStrip } from "../components/home/InstallStrip";
import { PhotoQuoteSection } from "../components/home/PhotoQuoteForm";
import { WarrantySection } from "../components/home/WarrantySection";
import { WarrantyHandling } from "../components/home/WarrantyHandling";
import { OfferReviews, FinalCta } from "../components/home/OfferReviews";

const Home = () => (
  <main data-testid="offer-home">
    <SEO
      title="TV Installation and Samsung Frame TV Installation in Rocky Mount, NC"
      description="TV sold, mounted, wires hidden, in one visit. We supply the TV and gear, mount it, hide the wires, and teach you the remote. Call (252) 545-0011."
      path="/"
    />
    <HomePromoBanner />
    <OfferHero />
    <BrandsBand />
    <OfferSteps />
    <HowQuotingWorks />
    <PhotoQuoteSection source="home" />
    <InstallPricing />
    <InstallStrip />
    <HomeInstallGallery />
    <PriceFactors />
    <WarrantySection />
    <WarrantyHandling />
    <OfferReviews />
    <FinalCta />
  </main>
);

export default Home;
